'use strict';

angular.module('programme')

.directive('goalList', function ()
{
    return {
        restrict: 'AE',
        replace: true,
        templateUrl: 'modules/programme/editor-components/goal-list/goalList.html',
        controller: 'GoalListCtrl',
        controllerAs: '$ctrl',
    };
})

.controller('GoalListCtrl', function ($scope, ListController)
{
    $scope.defaultGoal = {
        number: '01<sup>+1</sup>',
        details: 'Goal (details)',
        hasBreak: false
    };

    $scope.data.list = $scope.data.list || [angular.copy($scope.defaultGoal)];

    $scope.$list = new ListController($scope.data.list, {
        defaultItem: $scope.defaultGoal,
    });

    $scope.toggleBreak = function(goal) {
        goal.hasBreak = !goal.hasBreak;
    }

});
